import React from "react";
import ViewModuleIcon from "@material-ui/icons/ViewModule";

function CardViewIcon() {
  return <ViewModuleIcon />;
}
export default CardViewIcon;
